import QTable from 'quasar/src/components/table/QTable.js';
import { defineComponent, ref, computed } from "vue";
import { commonStore } from "~/store/CommonStore";
export default defineComponent({
    name: "MyPageTable",
    extends: {
        QTable
    },
    props: {
        rowsPerPageLabel: {
            default: "ページあたりの行数"
        },
        noDataLabel: {
            default: "データが見つかりませんでした。"
        },
        rowsPerPageOptions: {
            type: Array,
            default: () => commonStore.mypageTableSetting.rowPerPageOptions
        },
        class: {
            default: "cursor-pointer"
        },
        executeDate: {
            type: String
        },
        request: {
            type: Function,
            required: true
        },
        isDesplayPagenation: {
            type: Boolean,
            default: true
        },
        enableSelection: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Array,
            default: () => []
        },
        hideBottomRow: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:selected", "update:pagination", "changeAll"],
    setup: (props, { emit }) => {
        QTable.setup;
        const tableElement = ref(null);
        const selectedModel = computed({
            get: () => props.selected,
            set: val => {
                emit("update:selected", val);
            }
        });
        const innerPagination = computed({
            get: () => props.pagination,
            set: val => {
                emit("update:pagination", val);
            }
        });
        const onUpdate = (pag) => {
            tableElement.value?.setPagination({
                ...tableElement.value?.pagination,
                page: 1,
                rowsPerPage: pag
            });
        };
        const onClick = (requestData) => {
            if (requestData.pagination.rowsNumber !== 0) {
                props.request(requestData.pagination);
            }
        };
        const isAllSelected = ref(false);
        const changeAll = () => {
            isAllSelected.value = !isAllSelected.value;
            emit("changeAll", isAllSelected.value);
        };
        return {
            props,
            tableElement,
            selectedModel,
            innerPagination,
            onUpdate,
            onClick,
            changeAll
        };
    }
});
